var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcId(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id-card 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 62368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1435",
    d: "M8.21928 7.58884C8.21928 8.30067 7.64223 8.87773 6.93039 8.87773C6.21856 8.87773 5.6415 8.30067 5.6415 7.58884C5.6415 6.87701 6.21856 6.29995 6.93039 6.29995C7.64223 6.29995 8.21928 6.87701 8.21928 7.58884Z",
    stroke: "#141BEB",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.8525 12.6213C8.8525 12.9615 9.12855 13.2375 9.46875 13.2375C9.80895 13.2375 10.085 12.9615 10.085 12.6213V12.2671C10.085 11.1455 9.17355 10.2341 8.05204 10.2341H5.57296C4.45145 10.2341 3.54 11.1455 3.54 12.2671V12.6213C3.54 12.9615 3.81605 13.2375 4.15625 13.2375C4.49645 13.2375 4.7725 12.9615 4.7725 12.6213V12.2671C4.7725 11.8259 5.13184 11.4666 5.57296 11.4666H8.05204C8.49316 11.4666 8.8525 11.8259 8.8525 12.2671V12.6213Z",
    fill: "#141BEB",
    stroke: "#141BEB",
    strokeWidth: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22253",
    x: 1.5,
    y: 3,
    width: 17,
    height: 13.2222,
    rx: 1.88889,
    stroke: "#141BEB",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 248",
    d: "M11.8887 6.30542H15.6664",
    stroke: "#141BEB",
    strokeWidth: 1.41667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 249",
    d: "M11.8887 9.61108H15.6664",
    stroke: "#141BEB",
    strokeWidth: 1.41667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 250",
    d: "M11.8887 12.4443H15.6664",
    stroke: "#141BEB",
    strokeWidth: 1.41667,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcId);
export default __webpack_public_path__ + "static/media/oc-id.096d13b6781afeaaca07ca5aeae62c35.svg";
export { ForwardRef as ReactComponent };